/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import {
  DeliveryOrderDetailFragmentDoc,
  CartRestaurantFragmentDoc,
  CartLineItemFragmentDoc,
  CartLedgerFragmentDoc,
  CartDataFragmentDoc,
} from '../../../hooks/useCart/GraphQL/Cart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateOrderInput = {
  readonly deliveryOrderDetail?: DeliveryOrderDetailInput | null | undefined;
  readonly multipartyOrderDetails?: MultipartyDetailInput | null | undefined;
  /** The restaurant ID for this order */
  readonly restaurantId: number;
};

export type DeliveryOrderDetailInput = {
  readonly addressId: string | number;
  readonly deliveryFee: number;
  readonly tip: number;
  readonly vendor: string;
  readonly vendorRestaurantId: string;
};

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type LocationByAddressIdInput = {
  /** id for an address present in the current session. */
  readonly addressId: string | number;
  readonly useCartRestaurant?: boolean | null | undefined;
};

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type MultipartyDetailInput = {
  readonly hostName: string;
};

export type OrderState =
  | 'Active'
  | 'Canceled'
  | 'Complete'
  | 'Discarded'
  | 'LockedChangeLocation'
  | 'LockedCheckout';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type GroupOrderRestaurantQueryVariables = Exact<{
  id: string | number;
}>;

export type GroupOrderRestaurantQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly isOutpost: boolean;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  } | null;
};

export type GroupOrderDeliveryLocationQueryVariables = Exact<{
  input: Types.LocationByAddressIdInput;
  addressId: string | number;
}>;

export type GroupOrderDeliveryLocationQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly name: string | null;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  } | null;
  readonly locationByAddressId:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly deliveryFee: number;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly name: string;
        };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type GroupOrderCreateOrderMutationVariables = Exact<{
  input: Types.CreateOrderInput;
}>;

export type GroupOrderCreateOrderMutation = {
  readonly createOrder:
    | {
        readonly __typename: 'CreateOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'InvalidAddress' }
    | { readonly __typename: 'MultipartyOrderNotEnabled'; readonly errorMessage: string }
    | { readonly __typename: 'UnauthorizedOrderModification'; readonly errorMessage: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const GroupOrderRestaurantDocument = gql`
  query GroupOrderRestaurant($id: ID!) {
    restaurant(id: $id) {
      id
      __typename
      name
      isOutpost
      address
      city
      state
      zipCode
    }
  }
`;

export function useGroupOrderRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderRestaurantQuery, GroupOrderRestaurantQueryVariables>({
    query: GroupOrderRestaurantDocument,
    ...options,
  });
}
export const GroupOrderDeliveryLocationDocument = gql`
  query GroupOrderDeliveryLocation($input: LocationByAddressIdInput!, $addressId: ID!) {
    address(addressId: $addressId) {
      id
      __typename
      name
      street
      secondaryStreet
      city
      state
      zipCode
    }
    locationByAddressId(input: $input) {
      __typename
      ... on Location {
        deliveryFee
        restaurant {
          id
          __typename
          name
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useGroupOrderDeliveryLocationQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderDeliveryLocationQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderDeliveryLocationQuery, GroupOrderDeliveryLocationQueryVariables>({
    query: GroupOrderDeliveryLocationDocument,
    ...options,
  });
}
export const GroupOrderCreateOrderDocument = gql`
  mutation GroupOrderCreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      __typename
      ... on CreateOrderSuccess {
        order {
          ...CartData
        }
      }
      ... on MultipartyOrderNotEnabled {
        errorMessage
      }
      ... on UnauthorizedOrderModification {
        errorMessage
      }
      ... on ValidationError {
        message
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${CartDataFragmentDoc}
`;

export function useGroupOrderCreateOrderMutation() {
  return Urql.useMutation<GroupOrderCreateOrderMutation, GroupOrderCreateOrderMutationVariables>(
    GroupOrderCreateOrderDocument,
  );
}
